import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVoiceAndVideo: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconVoiceAndVideo"><Path d="M7 4C4.79086 4 3 5.79086 3 8V13C3 15.2091 4.79086 17 7 17C9.20914 17 11 15.2091 11 13V8C11 5.79086 9.20914 4 7 4Z" fill="currentColor"/><Path d="M13 5V7H18V17H15V19H20V15.443L24 16.943V7.057L20 8.557V5H13Z" fill="currentColor"/><Path d="M2 13V12H0V13C0 16.866 3.13401 20 7 20C10.866 20 14 16.866 14 13V12H12V13C12 15.7614 9.76142 18 7 18C4.23858 18 2 15.7614 2 13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVoiceAndVideo;
